import {ChangeEvent, FC, useRef} from 'react';
import {Button, styled, Tooltip, Typography} from '@mui/material';
import DocIconSwitcher from '../../../../ui/doc-icon-switcher/DocIconSwitcher';
import {FieldError} from 'react-hook-form';
import {Stack} from '@mui/system';
import {green} from '@mui/material/colors';
import {get} from 'lodash';

interface Props {
  accept?: string;
  file: File | null;
  error?: FieldError;
  onChange?: (file: File | null) => void;
}

export const ContractFormFileField: FC<Props> = ({accept, file, error, onChange}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChose = () => inputRef?.current?.click();
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(get(e, 'target.files[0]', null));
  };

  return (
    <Stack direction="row" justifyContent="space-between" gap={2}>
      <StyledInput accept={accept} ref={inputRef} type="file" onChange={handleFileChange} />
      <Tooltip placement="bottom-start" title={file?.name}>
        <StyledFileContainer>
          <DocIconSwitcher docName={file?.name ?? ''} error={!!error} />
          <Typography noWrap textOverflow="ellipsis" {...(error && {color: 'error'})}>
            {file?.name ?? error?.message ?? 'Файл не выбран'}
          </Typography>
        </StyledFileContainer>
      </Tooltip>

      <StyledAddButton variant="contained" onClick={handleFileChose}>
        {file?.name ? 'Заменить файл' : 'Выбрать файл'}
      </StyledAddButton>
    </Stack>
  );
};

const StyledFileContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: '24px 1fr',
  alignItems: 'center',
  gap: 8,
  maxWidth: '406px',
});

const StyledAddButton = styled(Button)({
  height: '40px',
  fontSize: '0.87rem',
  letterSpacing: '0',
  backgroundColor: green[500],
  textTransform: 'none',
  textWrap: 'nowrap',
  '&:hover': {backgroundColor: green[600]},
  '&.MuiButton-root': {marginLeft: 'auto'},
});

const StyledInput = styled('input')({
  position: 'absolute',
  display: 'none',
});
